module.exports = __webpack_public_path__ + "img/equine-in-hands.15a90150.jpg";